import { render, staticRenderFns } from "./livingSet.vue?vue&type=template&id=4d205b5a&scoped=true&"
import script from "./livingSet.vue?vue&type=script&lang=js&"
export * from "./livingSet.vue?vue&type=script&lang=js&"
import style0 from "./livingSet.vue?vue&type=style&index=0&id=4d205b5a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d205b5a",
  null
  
)

export default component.exports